import { ColorSource, Container, Graphics, Sprite } from "pixi.js";
import { DRect } from "src/app/binst/primitives/drawable-rect";
import { Rect } from "src/app/binst/primitives/rect";

type RectConstructorType = ConstructorParameters<typeof Rect>[0];

export class DebugRectPixi {
  sprite: Container;
  colour: ColorSource;
  dRect: DRect;
  roundness: number;
  graphics: Graphics;

  constructor(
    config: RectConstructorType & {
      colour?: ColorSource;
      roundness?: number;
    },
  ) {
    this.dRect = new DRect(config);
    this.graphics = new Graphics();
    this.sprite = new Container();
    this.dRect.render(this.graphics);
    this.sprite.addChild(this.graphics);
  }
}
